export const socialLoginConfig = {
    google: {
      clientId: '1068591848947-dfmues44s14vfku68mdkd818sa5fnnpp.apps.googleusercontent.com',
    },
    microsoft: {
        clientId: 'e61ccb73-be25-4f31-a708-0156bd0dda6d'
    }
};